package com.dotdrives.web

private val publicUuid =
    Regex("[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}")

data class PublicGivingRoute(
    val orgId: String,
    val slug: String,
    val payment: String? = null,
    val operationId: String? = null,
)

fun parsePublicGivingRoute(hash: String): PublicGivingRoute? {
    val parts = hash.removePrefix("#").substringBefore('?').split('/')
    if (
        parts.size != 4 ||
            parts[0] != "" ||
            parts[1] != "give" ||
            !publicUuid.matches(parts[2]) ||
            !Regex("[-a-zA-Z0-9_]{1,120}").matches(parts[3])
    )
        return null
    val pairs =
        hash.substringAfter('?', "").split('&').filter(String::isNotBlank).map {
            it.substringBefore('=') to it.substringAfter('=', "")
        }
    if (pairs.map { it.first }.distinct().size != pairs.size) return null
    val params = pairs.toMap()
    val payment = params["payment"]
    val operation = params["operation_id"]
    if (payment != null && payment !in listOf("return", "canceled")) return null
    if (operation != null && !publicUuid.matches(operation)) return null
    return PublicGivingRoute(parts[2], parts[3], payment, operation)
}

fun restorePublicGivingHash(hash: String, search: String, saved: String?): String? {
    if (saved == null || parsePublicGivingRoute(saved) == null || hash.startsWith("#/")) return null
    val callback =
        hash.removePrefix("#").split('&').any { it.startsWith("access_token=") } ||
            search.removePrefix("?").split('&').any { it.startsWith("code=") }
    if (
        !callback || search.removePrefix("?").split('&').any { it=="signin=1" } || inviteIdFromLocation(hash, search) != null || hasGiverCallback(search) ||
            hasRecoveryRouteHint(hash, search) ||
            parseAppRoute(hash, search) in setOf(AppRoute.ResetPassword, AppRoute.Admin)
    )
        return null
    return saved
}
